import { BedDoubleOutlineIcon } from './BedDoubleOutlineIcon';

/**
 * author: Google
 * id 6061EF08-3805-4F30-88A1-0DC3419E6989
 * name bed-double-outline
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bed-double-outline.svg
 * tags
 * - Home Automation 
 * - Holiday 
 */
export const BedroomOutlineIcon = BedDoubleOutlineIcon;
export default BedroomOutlineIcon